import React from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import StyledTypography from "../common/StyledTypography";
import AssignButton from "../common/assignButton";

export default function DevToUserTableRow({ row, labelId, iKey, setDisabledTab, setValue }) {
    const { t } = useTranslation();
    const theme = useTheme();
    let email = "none";
    let mobile = "none";
    for (let i in row.contact) {
        if (row.contact[i].contact_type === "email_address" && row.contact[i].primary_contact === true) {
            email = row.contact[i].value;
        } else if (row.contact[i].contact_type === "tel_mobile" && row.contact[i].primary_contact === true) {
            mobile = row.contact[i].value;
        }
    }

    function handleAssign() {
        setDisabledTab(false);
        setValue(1);
        localStorage.setItem("assignToUser", row.profile_id)
    }

    let url = "../FakeUser.png";
    return (
        <TableRow hover role="checkbox" tabIndex={-1} key={iKey} sx={{ cursor: "pointer" }}>
            <TableCell sx={{ height: "100%", color: theme.palette.custom.text }} component="th" id={labelId} scope="row" padding="none">
                <Box sx={{ textAlign: "center", width: "100%", display: "flex", flexFlow: "row" }}>
                    <span className="pfpSpan" style={{ width: "40px", height: "40px", backgroundImage: `url(${url})`, backgroundPosition: "center", backgroundSize: "cover" }}></span>
                    <StyledTypography sx={{ ml: "8px" }} variant="subtitle2">
                        {row.firstname}
                    </StyledTypography>{" "}
                </Box>
            </TableCell>
            <TableCell align="left">
                <StyledTypography variant="subtitle2">{row.lastname}</StyledTypography>
            </TableCell>
            <TableCell align="left">
                <StyledTypography variant="subtitle2">{email}</StyledTypography>
            </TableCell>
            <TableCell align="left">
                <StyledTypography variant="subtitle2">{mobile}</StyledTypography>
            </TableCell>
            <TableCell align="left">
                <Button className="viewUser" hidden onClick={handleAssign}>
                    <AssignButton type={"add"} title={"Assign"} text={`${t("Select")} ${t("User")}`} />
                </Button>
            </TableCell>
        </TableRow>
    );
}
DevToUserTableRow.propTypes = {
    row: PropTypes.object.isRequired,
    setDisabledTab: PropTypes.func,
    setValue: PropTypes.func,
    iKey: PropTypes.number,
    labelId: PropTypes.string,
};
